import ResourceManager from "@/components/admin/ResourceManager";

export default function SolutionsAdmin() {
  return (
    <ResourceManager
      collection="solutions" title="Solutions logicielles" subtitle="Gérez vos logiciels et solutions digitales."
      aiKind="solution"
      columns={[
        { key: "name", label: "Nom" },
        { key: "category", label: "Catégorie" },
        { key: "price", label: "Prix" },
      ]}
      fields={[
        { name: "name", label: "Nom", type: "text", placeholder: "Vision POS" },
        { name: "category", label: "Catégorie", type: "select", options: ["Logiciel de gestion", "SaaS", "Application métier", "Application mobile", "Plateforme digitale"] },
        { name: "short_desc", label: "Description courte", type: "textarea" },
        { name: "description", label: "Description détaillée", type: "richtext", ai: true, aiFrom: "name" },
        { name: "problem", label: "Problème résolu", type: "textarea" },
        { name: "features", label: "Fonctionnalités", type: "list" },
        { name: "benefits", label: "Avantages", type: "list" },
        { name: "target", label: "Public cible", type: "text" },
        { name: "price", label: "Prix", type: "text", placeholder: "À partir de 150 000 FCFA" },
        { name: "pricing_model", label: "Formule tarifaire", type: "text" },
        { name: "image", label: "Image principale (URL)", type: "text" },
        { name: "seo_title", label: "SEO — Meta title", type: "text" },
        { name: "seo_description", label: "SEO — Meta description", type: "textarea" },
        { name: "seo_keywords", label: "SEO — Mots-clés", type: "text" },
      ]}
    />
  );
}
